<template>
  <router-link :to="{ name: to }" v-slot="{ href, navigate, isActive }" custom>
    <li class="main-menu-item" :class="{ 'main-menu-item_active': isActive }">
      <a :id="id" :href="href" class="main-menu-item__link" @click="navigate">
        <i v-if="icon" class="main-menu-item__icon">
          <font-awesome-icon :icon="icon" />
        </i>
        <span>{{ label }}</span>
      </a>
      <ul v-if="hasChildren && isActive" class="main-menu-item__children">
        <main-menu-item v-for="child in children" :key="child.id" v-bind="child"></main-menu-item>
      </ul>
    </li>
  </router-link>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'MainMenuItem',

  components: {
    FontAwesomeIcon,
    // eslint-disable-next-line import/no-self-import
    MainMenuItem: () => import('./MainMenuItem'),
  },

  props: {
    id: {
      default: null,
      type: String,
    },
    to: {
      default: '',
      type: String,
    },
    icon: {
      default: null,
      type: Array,
    },
    label: {
      default: null,
      type: String,
    },
    children: {
      default: () => [],
      type: Array,
    },
  },

  computed: {
    hasChildren() {
      return this.children.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-menu-item {
  margin: 0 0 10px;
  letter-spacing: 0.75px;
  color: white;
  border-left: 5px solid transparent;

  .main-menu-item {
    font-size: 16px;
    margin: 0 0 14px;
    border-left: none;
    background: transparent;

    .main-menu-item__link {
      margin: 0;
      padding: 2px 0 2px 70px;
    }
  }

  &_active {
    background: rgba(white, 0.1);
    border-left-color: $default-blue;

    > .main-menu-item__link {
      color: $default-blue;
    }
  }

  &__icon {
    font-size: 24px;
    min-width: 1.25em;
    width: 1.25em;
    height: 1em;
    text-align: center;
    margin: 6px 14px 6px 0;
  }

  &__children {
    margin: 0;
    padding: 0 0 2px;
  }

  &__link {
    display: flex;
    width: 100%;
    align-items: center;
    padding: 8px 0 8px 24px;
  }
}
</style>
